import {
  PaymentFormFields,
  type PaymentFormFieldsProps,
} from './PaymentFormFields'
import { SectionCard } from './PaymentCreateSectionCard'

export type PaymentSectionProps = Omit<PaymentFormFieldsProps, 'layout'> & {
  index: number
  title: string
}

export function PaymentSection({
  index,
  title,
  ...fieldsProps
}: PaymentSectionProps) {
  return (
    <SectionCard index={index} title={title}>
      <PaymentFormFields {...fieldsProps} layout='drawer' />
    </SectionCard>
  )
}
